import { useEffect } from "react";
import type { Action } from "@reduxjs/toolkit";
import { useAppDispatch } from "@redux/hooks";
import type { RequestState } from "@redux/state/shared-types";

// Remet l'état d'une action à zéro une fois son issue rendue (le bouton de sauvegarde a vu « Enregistré » ou « Échec »),
// et quand l'écran se démonte avant ce rendu (succès suivi d'une navigation) : un retour sur l'écran ne la rejoue pas
export const useResetWhenSettled = (processing: RequestState, reset: () => Action) => {
  const dispatch = useAppDispatch();
  useEffect(() => {
    if (processing === "success" || processing === "failed") dispatch(reset());
  }, [processing, reset, dispatch]);
  useEffect(() => () => void dispatch(reset()), [reset, dispatch]);
};
